/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export interface DataCleanupActionRequest { 
    action: DataCleanupActionRequest.ActionEnum;
    dataInstanceUid: string;
    fieldId?: string;
    fieldValue?: string;
}
export namespace DataCleanupActionRequest {
    export type ActionEnum = 'UNKNOWN' | 'DELETE_INSTANCE' | 'CLEAR_FIELD' | 'MANUAL_FIX';
    export const ActionEnum = {
        Unknown: 'UNKNOWN' as ActionEnum,
        DeleteInstance: 'DELETE_INSTANCE' as ActionEnum,
        ClearField: 'CLEAR_FIELD' as ActionEnum,
        ManualFix: 'MANUAL_FIX' as ActionEnum
    };
}


